import { ReactElement, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { buildErrorMessage } from '@constants'
import { AxiosError } from 'axios'
import { storeyToLabel } from '@editor/pages/Plans/components/AddPlanDialog/components/utils'
import { useMutation } from '@tanstack/react-query'
import { useSnackbar } from '@ui/snackbar'
import { useModelStore, roofStoreyKey } from '@editorStores'
import { downLoadFile } from '@utils'
import { postDownloadPositionPlanDxf } from '@mutations'
import ExportMultiSelectItem from '../../../ExportMultiSelectItem'
import { positionPlanDxfFilename, storeysTopToBottom } from '../../utils'

const CombinedPositionPlanDxfItem = (): ReactElement => {
  const { enqueueSnackbar } = useSnackbar()
  const { projectId } = useParams()

  const availableStoreys = useModelStore(state => state.availableStoreys)

  const sortedStoreys = useMemo(() => storeysTopToBottom(availableStoreys), [availableStoreys])

  const availableStoreysOptions = useMemo(
    () =>
      sortedStoreys.map(storey => ({
        label: storeyToLabel(storey),
        value: storey,
      })),
    [sortedStoreys],
  )

  const [storeys, setStoreys] = useState([roofStoreyKey])

  const { isLoading, mutate } = useMutation(
    (selectedStoreys: Array<string>) =>
      postDownloadPositionPlanDxf.request(projectId as string, selectedStoreys),
    {
      onSuccess: (data: Blob, selectedStoreys) => {
        downLoadFile(data, 'application/dxf', positionPlanDxfFilename(selectedStoreys))
        enqueueSnackbar('DXF wurde heruntergeladen', { variant: 'success' })
      },
      onError: (error: AxiosError) => {
        enqueueSnackbar(buildErrorMessage(error, 'Fehler beim Herunterladen des DXF'), {
          variant: 'error',
        })
      },
    },
  )

  return (
    <ExportMultiSelectItem
      title="Dach + weitere"
      isLoading={isLoading}
      onClick={() => mutate(storeys)}
      options={availableStoreysOptions}
      selectedOptions={storeys}
      buttonSize="small"
      data-cy="button-position-plan-dxf-combined"
      handleChange={event => {
        const { value } = event.target
        setStoreys(typeof value === 'string' ? value.split(',') : value)
      }}
    />
  )
}

export default CombinedPositionPlanDxfItem
